module.exports = __webpack_public_path__ + "assets/img/Fulltransaction.e2aef45c.png";